import DefaultThumbnail from "../DefaultThumbnail";
import * as s from "./ThumbnailStyled";

import { useMemo, useState } from "react";
import Spinner from "components/atoms/loader/Spinner";
import ThumbnailError from "./ThumbnailError";
import moment from "moment";

type CVVThumbnailProps = {
  videoLoss: boolean;
  thumbnailUrl: string | undefined;
  isLazy?: boolean;
  isRecorderList?: boolean;
  errorStatus?: string;
  isAnalyzing?: boolean;
  eventDate?: string;
  showAnalyzingCover?: boolean;
};

function CVVThumbnail(props: CVVThumbnailProps): JSX.Element {
  const [thumbnailAvailable, setThumbnailAvailable] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);

  const imageOnErrorHandler = (
    event: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    setThumbnailAvailable(true);
    event.currentTarget.style.display = "none";
  };

  const is2HourAfterEventDate = useMemo(
    () =>
      props.eventDate
        ? moment(props.eventDate).add(2, "hours").isAfter(moment())
        : false,
    [props.eventDate]
  );

  return (
    <DefaultThumbnail>
      {props.thumbnailUrl === undefined ||
      props.thumbnailUrl === "" ||
      (props.errorStatus !== "Success" && props.errorStatus !== "Ready") ? (
        <ThumbnailError
          isRecorderList={props.isRecorderList}
          errorStatus={props.errorStatus}
        />
      ) : (
        <>
          <s.ImageBg>
            <div className="black-filter"></div>
            {thumbnailAvailable ? (
              <ThumbnailError
                isRecorderList={props.isRecorderList}
                errorStatus={"thumbnailnotavailable"}
              />
            ) : (
              <>
                <img
                  src={props.thumbnailUrl}
                  alt="recorder thumbnail"
                  onLoad={() => {
                    setLoaded(true);
                  }}
                  onError={imageOnErrorHandler}
                  loading="lazy"
                  className="thumbnail-url"
                />
                {!loaded && (
                  <s.Loading>
                    <Spinner />
                  </s.Loading>
                )}
              </>
            )}
          </s.ImageBg>
        </>
      )}
      {props.showAnalyzingCover &&
        (props.isAnalyzing || props.errorStatus === "Ready") && (
          <AnalyzingCover
            label={
              thumbnailAvailable &&
              !is2HourAfterEventDate &&
              props.errorStatus === "Ready"
                ? "Uploading"
                : "Analyzing"
            }
          />
        )}
    </DefaultThumbnail>
  );
}

export default CVVThumbnail;

const AnalyzingCover = ({ label }: { label: string }) => {
  return (
    <s.AnalyzingCover>
      <span className="txt">{label}</span>
      <Spinner inline={true} size={8} />
    </s.AnalyzingCover>
  );
};
